import React, { useCallback, useMemo, useReducer } from 'react';

import lightboxConstants    from './lightbox.constants';
import LightboxContext      from './lightbox.context';
import lightboxReducer      from './lightbox.reducer';
import lightboxInitialState from './lightbox.state';

/**
 * @type {React.FC}
 */

const LightboxProvider = function({
  children,
  value = lightboxInitialState,
}) {
  const [state, dispatch] = useReducer(lightboxReducer, value);

  const closeLightbox    = useCallback(() => {
    dispatch({ type: lightboxConstants.LIGHT_BOX_CLOSE });
  }, [dispatch]);
  const loadedLightbox   = useCallback(() => {
    dispatch({ type: lightboxConstants.LIGHT_BOX_LOADED });
  }, [dispatch]);
  const navigateLightbox = useCallback((slide) => {
    dispatch({
      type: lightboxConstants.LIGHT_BOX_NAVIGATE,
      slide,
    });
  }, [dispatch]);
  const openLightbox     = useCallback((slides, current) => {
    dispatch({
      type: lightboxConstants.LIGHT_BOX_OPEN,
      slides,
      current,
    });
  }, [dispatch]);

  const context = useMemo(() => ({
    ...state,
    closeLightbox,
    loadedLightbox,
    navigateLightbox,
    openLightbox,
  }), [closeLightbox, loadedLightbox, navigateLightbox, openLightbox, state]);

  return (
    <LightboxContext.Provider value={context}>
      {children}
    </LightboxContext.Provider>
  );
};

export default LightboxProvider;